import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { http } from "../../lib/api";

// Recordatorio en el portal mientras falte el perfil para cobrar (solo referenciadores dados de alta en línea).
export const CobroBanner = () => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/portal/perfil-cobro").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d?.aplica || d.completo) return null;
  return (
    <Link to="/portal/cobro" className="flex items-center gap-3 rounded-2xl border border-[#E8643C]/40 bg-[#FBE9DF] p-4 text-sm text-[#7A3712] transition-transform hover:-translate-y-0.5" data-testid="portal-cobro-banner">
      <AlertCircle size={18} className="shrink-0" /><span><b>Completa tu perfil para cobrar.</b> Falta: {d.falta}. Lo necesitamos antes de tu primer pago de comisiones.</span>
    </Link>
  );
};
